import wire from '../wire';

var template = `
  <div style="position:fixed;left:0;right:0;bottom:0;top:0;background:#000;z-index:99999999">
    <div class="turn-off screen">
    </div>
  </div>
`;

var module = wire(
  'logout',
  template,
  function LogoutController(AuthService, $timeout) {
    'ngInject';
    $timeout(() => {
      AuthService.logout();
    }, 1000);
  },
  'LogoutController'
);

export default module;



// WEBPACK FOOTER //
// ./app/pages/logout/index.js